import { render } from "./InvoiceStatistics.vue?vue&type=template&id=609788b0&scoped=true"
import script from "./InvoiceStatistics.vue?vue&type=script&lang=js"
export * from "./InvoiceStatistics.vue?vue&type=script&lang=js"

import "./InvoiceStatistics.vue?vue&type=style&index=0&id=609788b0&scoped=true&lang=css"

import exportComponent from "/var/www/likvio.se/html/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-609788b0"]])

export default __exports__